export const STARS = 'INDEXED';
